import React from "react";
import "./Home.scss";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import { ga_push } from "../../../services/analytics";
import Studio from "../../Animations/Studio/Studio";
const Home = () => {
  const StartVote = () => {
    ga_push("navigation_events", "Navigation", "Start Voting");
    setPageView(1);
  };

  const { setPageView } = useContext(AppContext);

  return (
    <div className="home">
      <div className="bg"></div>
      <div className="page-wrapper">
        <div className="text">
          <div className="yellow-bar-wrapper">
            <div className="yellow-bar"></div>
          </div>
          <h2>המצעד</h2>
          <h2>הבינלאומי</h2>
          <h2>השנתי 2020</h2>
          <h3>עם דלית רצ'שטר</h3>
        </div>
        <div className="mobile-only">
          <Studio />
        </div>
        <h4>
          סוף סוף זה קורה: הגיע הזמן להיפרד משנת 2020 (לא נתגעגע!) ומהמוזיקה הנפלאה שעזרה לנו לשרוד את השנה.
        </h4>
        <h5>
          לקראת המצעד הבינלאומי השנתי של ynet וגלגלצ, אתם מוזמנים לבחור את השירים ואת האמנים שהכי אהבתם- וכמובן, גם את השיר הגרוע ביותר.
          <br className="mobile-only"/>
          {" "}
          אז הצביעו, השפיעו, ואולי 
           תזכו בטלוויזיית NanoCell ובמקרן קול מתנת
          <span className="lg-logo"></span>
        </h5>
        <h6 className="desktop-only">
          התוצאות ייחשפו במשדר מיוחד בהגשת דלית רצ'שטר, שיועבר בשידור חי ב-ynet ובגלגלצ ב-31 בדצמבר בין השעות 18:00-14:00.
        </h6>
        <button className="start-button" onClick={() => StartVote()}>
          התחילו להצביע
        </button>
      </div>
      <div className="desktop-only">
        <Studio />
      </div>
      {/* <Footer/> */}
    </div>
  );
};

export default Home;
